// Global Nav
$(document).ready(function() {
    $("#nav-hamburger").click(function(e) {
        e.preventDefault();
        $(this).toggleClass("mobile-nav-is-active");
        $(".nav-menu").toggle();
    });

    $(".nav-menu li a").each(function() {
        if ($(this).next().length > 0) {
            $(this).addClass("parent");
        }
    });

    updateGlobalNav();
});

$(window).bind('resize orientationchange', updateGlobalNav);

function updateGlobalNav() {
    $('.nav-link-hover-color').each(function() {
        $(this).removeClass('nav-link-hover-color');
    });

    if (window.innerWidth <= 991) {
        if (!$("#nav-hamburger").hasClass("mobile-nav-is-active")) {
            $(".nav-menu").hide();
        } else {
            $(".nav-menu").show();
        }

        $(".nav-menu li").unbind("mouseenter mouseleave");

        $(".nav-menu li a.parent").unbind("click").click(function(e) {
            e.preventDefault();

            // Close Other expanded navs on the same level when another nav is expanded
            // Comment back in the if check if you only want this to work for top level nav
            let parentNav = $(this).closest('ul');
            // if (parentNav.hasClass('global-nav-level-1')) {
                let parentLi = $(this).parent();
                parentNav.find('> li.hover').each(function() {
                    if (!$(this).is(parentLi)) {
                        $(this).removeClass('hover');
                    }
                });
            // }

            // Toggle visiblity of current target
            $(this).parent("li").toggleClass("hover");

            $('.nav-link-hover-color').each(function() {
                $(this).removeClass('nav-link-hover-color');
            });

            if ($(this).parent("li").hasClass("hover")) {
                $(this).addClass("nav-link-hover-color");
            }
        });

        updateLevel3('mobile');
    } else {
        $(".nav-menu").show();
        $(".nav-menu li").removeClass("hover");
        $(".nav-menu li a").unbind("click");

        // Hover Color
        $(".nav-menu li a").unbind("mouseenter").bind("mouseenter", function() {
            $(this).addClass("nav-link-hover-color");
        });
        $(".nav-menu li a").unbind("mouseleave").bind("mouseleave", function() {
            $(this).removeClass("nav-link-hover-color");
        });

        // Hover
        $(".nav-menu li").unbind("mouseenter").bind("mouseenter", function() {
            $(this).addClass("hover");
        });
        $(".nav-menu li").unbind("mouseleave").bind("mouseleave", function() {
            $(this).removeClass("hover");
        });

        updateLevel3('desktop');
    }
}

function updateLevel3(screen) {
    document.querySelectorAll('.global-nav-level-3').forEach(function(el) {
        if (!el.classList.contains(screen + '-touched')) {
            let parent = el.closest('.global-nav-level-2');
            let parentBox = parent.getBoundingClientRect();
            let childBox = el.getBoundingClientRect();
            let navbarHeight = document.querySelector('#global-nav-spacing').getBoundingClientRect().height;

            if (screen === 'mobile') {
                el.style.height = 'initial';
                parent.style.height = 'initial';
                el.style.top = 0;
                $(".desktop-touched").removeClass("desktop-touched");
            } else {
                let maxHeight = Math.max(parentBox.height, childBox.height);
                el.style.height = maxHeight + 'px';
                parent.style.height = maxHeight + 'px';
                if (el.offsetTop === 0 ) {
                    el.style.top = (parentBox.top - childBox.top) + 'px';
                } else {
                    el.style.top = (parentBox.top - childBox.top + navbarHeight - 9) + 'px';
                }
                $(".mobile-touched").removeClass("mobile-touched");
            }

            el.classList.add(screen + '-touched');
        }
    });
}